import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-left: 12px;
`
export const CheckBoxContainer = styled.div`
  margin: 0 0.5%;
  font-size: 14px;
`

export const Text = styled.div`
  font-family: Circular-Std;
  width: 60%;
  text-align: left;
  font-size: 16px;
  padding: 0 16px;

  @media (max-width: 500px) {
    padding: 0;
    max-width: 70px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
